export default __webpack_public_path__ + "static/media/38t.e2b57ad8.jpg";